function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["resume", "tools"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { DefaultChatTransport, lastAssistantMessageIsCompleteWithToolCalls } from 'ai';
import { Chat } from "../../lib/chat/index.js";
import { checkRendering, createDocumentationMessageGenerator, createSendEventForHits, getAppIdAndApiKey, noop, warning } from "../../lib/utils/index.js";
var withUsage = createDocumentationMessageGenerator({
  name: 'chat',
  connector: true
});
export default (function connectChat(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  checkRendering(renderFn, withUsage());
  return function (widgetParams) {
    process.env.NODE_ENV === 'development' ? warning(false, 'Chat is not yet stable and will change in the future.') : void 0;
    var _ref = widgetParams || {},
      _ref$resume = _ref.resume,
      resume = _ref$resume === void 0 ? false : _ref$resume,
      _ref$tools = _ref.tools,
      tools = _ref$tools === void 0 ? {} : _ref$tools,
      options = _objectWithoutProperties(_ref, _excluded);
    var _chatInstance;
    var input = '';
    var open = false;
    var sendEvent;
    var setInput;
    var setOpen;
    var setMessages = function setMessages(messagesParam) {
      if (typeof messagesParam === 'function') {
        messagesParam = messagesParam(_chatInstance.messages);
      }
      _chatInstance.messages = messagesParam;
    };
    var makeChatInstance = function makeChatInstance(instantSearchInstance) {
      var transport;
      var _getAppIdAndApiKey = getAppIdAndApiKey(instantSearchInstance.client),
        _getAppIdAndApiKey2 = _slicedToArray(_getAppIdAndApiKey, 2),
        appId = _getAppIdAndApiKey2[0],
        apiKey = _getAppIdAndApiKey2[1];
      if ('transport' in options && options.transport) {
        transport = new DefaultChatTransport(options.transport);
      }
      if ('agentId' in options && options.agentId) {
        var agentId = options.agentId;
        if (!appId || !apiKey) {
          throw new Error(withUsage('Could not extract Algolia credentials from the search client.'));
        }
        transport = new DefaultChatTransport({
          api: "https://".concat(appId, ".algolia.net/agent-studio/1/agents/").concat(agentId, "/completions?compatibilityMode=ai-sdk-5"),
          headers: {
            'x-algolia-application-id': appId,
            'x-algolia-api-Key': apiKey
          }
        });
      }
      if (!transport) {
        throw new Error(withUsage('You need to provide either an `agentId` or a `transport`.'));
      }
      if ('chat' in options) {
        return options.chat;
      }
      return new Chat(_objectSpread(_objectSpread({}, options), {}, {
        transport: transport,
        sendAutomaticallyWhen: lastAssistantMessageIsCompleteWithToolCalls,
        onToolCall: function onToolCall(_ref2) {
          var toolCall = _ref2.toolCall;
          var tool = tools[toolCall.toolName];
          if (!tool) {
            if (process.env.NODE_ENV === 'development') {
              throw new Error("No tool implementation found for \"".concat(toolCall.toolName, "\". Please provide a tool implementation in the `tools` prop."));
            }
            return _chatInstance.addToolResult({
              output: "No tool implemented for \"".concat(toolCall.toolName, "\"."),
              tool: toolCall.toolName,
              toolCallId: toolCall.toolCallId
            });
          }
          if (tool.onToolCall) {
            var addToolResult = function addToolResult(_ref3) {
              var output = _ref3.output;
              return _chatInstance.addToolResult({
                output: output,
                tool: toolCall.toolName,
                toolCallId: toolCall.toolCallId
              });
            };
            return tool.onToolCall(_objectSpread(_objectSpread({}, toolCall), {}, {
              addToolResult: addToolResult
            }));
          }
          return Promise.resolve();
        }
      }));
    };
    return {
      $$type: 'ais.chat',
      init: function init(initOptions) {
        var _this = this;
        var instantSearchInstance = initOptions.instantSearchInstance;
        _chatInstance = makeChatInstance(instantSearchInstance);
        var render = function render() {
          renderFn(_objectSpread(_objectSpread({}, _this.getWidgetRenderState(initOptions)), {}, {
            instantSearchInstance: initOptions.instantSearchInstance
          }), false);
        };
        setOpen = function setOpen(o) {
          open = o;
          render();
        };
        setInput = function setInput(i) {
          input = i;
          render();
        };
        _chatInstance['~registerErrorCallback'](render);
        _chatInstance['~registerMessagesCallback'](render);
        _chatInstance['~registerStatusCallback'](render);
        if (resume) {
          _chatInstance.resumeStream();
        }
        renderFn(_objectSpread(_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        renderFn(_objectSpread(_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState) {
        return renderState;
      },
      getWidgetRenderState: function getWidgetRenderState(renderState) {
        var instantSearchInstance = renderState.instantSearchInstance,
          parent = renderState.parent;
        if (!_chatInstance) {
          this.init(_objectSpread(_objectSpread({}, renderState), {}, {
            uiState: {},
            results: undefined
          }));
        }
        if (!sendEvent) {
          sendEvent = createSendEventForHits({
            instantSearchInstance: renderState.instantSearchInstance,
            helper: renderState.helper,
            widgetType: this.$$type
          });
        }
        return {
          indexUiState: instantSearchInstance.getUiState()[parent.getIndexId()],
          input: input,
          open: open,
          sendEvent: sendEvent,
          setIndexUiState: parent.setIndexUiState.bind(parent),
          setInput: setInput,
          setOpen: setOpen,
          setMessages: setMessages,
          widgetParams: widgetParams,
          // Chat instance render state
          addToolResult: _chatInstance.addToolResult,
          clearError: _chatInstance.clearError,
          error: _chatInstance.error,
          id: _chatInstance.id,
          messages: _chatInstance.messages,
          regenerate: _chatInstance.regenerate,
          resumeStream: _chatInstance.resumeStream,
          sendMessage: _chatInstance.sendMessage,
          status: _chatInstance.status,
          stop: _chatInstance.stop
        };
      },
      dispose: function dispose() {
        unmountFn();
      },
      shouldRender: function shouldRender() {
        return true;
      },
      get chatInstance() {
        return _chatInstance;
      }
    };
  };
});